<div class="flex w-full animate-pulse flex-col space-y-16">
  {#each Array(4) as _}
    <div class="space-y-6">
      <div class="h-18 w-[10%] rounded-full bg-highlight bg-opacity-30" />
      <div class="h-40 w-full rounded-[15px] bg-highlight bg-opacity-30" />
    </div>
  {/each}
  <div class="h-[42px] w-[104px] rounded-[15px] bg-highlight bg-opacity-30" />
</div>
